"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Item = function (props) { return React.createElement("button", { type: "button", className: 'cdd-item__wrapper', role: "option", "aria-selected": props.selected, tabIndex: props.tabIndex, ref: props.setRef, "aria-posinset": props.position, "aria-setsize": props.setSize }, props.children); };
exports.Item = Item;
exports.Item.displayName = 'Item';
exports.Item.propTypes = {
    children: PropTypes.element.isRequired,
    setRef: PropTypes.func,
    tabIndex: PropTypes.number,
};
exports.default = exports.Item;
